import React from 'react';
import styles from '../../styles/icons/combinedIconTopRight.scss';
const CombinedIconTopRight = (props) => {
    const { className, colorSmall, MainIcon, SmallIcon } = props;
    const containerClass = `${styles.container} ${className || ''}`;
    const smallIconClass = `${styles.small_icon} ${styles[colorSmall]}`;
    const sanitizedProps = Object.assign({}, props);
    delete sanitizedProps.colorSmall;
    delete sanitizedProps.MainIcon;
    delete sanitizedProps.SmallIcon;
    return (React.createElement("span", Object.assign({}, sanitizedProps, { className: containerClass }),
        React.createElement(MainIcon, { className: styles.large_icon }),
        React.createElement(SmallIcon, { className: smallIconClass })));
};
export default CombinedIconTopRight;
